import { createAction } from 'redux-actions';
import {
  BOOTING,
  LOAD_CONFIG,
  LOAD_SESSION,
  LOAD_PLAYLISTS,
  LOGOUT,
  
} from './constants';

export const booting = createAction(BOOTING.ACTION);

export const loadConfig = createAction(LOAD_CONFIG.ACTION);
export const pendingLoadConfig = createAction(LOAD_CONFIG.PENDING);
export const configLoaded = createAction(LOAD_CONFIG.SUCCESS);
export const configLoadingError = createAction(LOAD_CONFIG.ERROR);

export const loadSession = createAction(LOAD_SESSION.ACTION);
export const pendingLoadSession = createAction(LOAD_SESSION.PENDING);
export const sessionLoaded = createAction(LOAD_SESSION.SUCCESS);
export const sessionLoadingError = createAction(LOAD_SESSION.ERROR);
export const logoutSession = createAction(LOGOUT.ACTION);


export const loadPlaylists = createAction(LOAD_PLAYLISTS.ACTION);
export const pendingLoadPlaylists = createAction(LOAD_PLAYLISTS.PENDING);
export const playlistsLoaded = createAction(LOAD_PLAYLISTS.SUCCESS);
export const playlistsLoadingError = createAction(LOAD_PLAYLISTS.ERROR);
